export const PROJECT_STATUS = {
  Planned: { label: 'برنامه‌ریزی', color: 'bg-slate-100 text-slate-700 border border-slate-200', dot: 'bg-slate-400' },
  'Shooting Day': { label: 'روز شوتینگ', color: 'bg-orange-100 text-orange-700 border border-orange-200', dot: 'bg-orange-400' },
  'Shooting Done': { label: 'شوتینگ تمام', color: 'bg-yellow-100 text-yellow-700 border border-yellow-200', dot: 'bg-yellow-400' },
  Editing: { label: 'در حال ادیت', color: 'bg-blue-100 text-blue-700 border border-blue-200', dot: 'bg-blue-400' },
  Review: { label: 'بررسی', color: 'bg-purple-100 text-purple-700 border border-purple-200', dot: 'bg-purple-400' },
  Delivered: { label: 'تحویل داده شد', color: 'bg-green-100 text-green-700 border border-green-200', dot: 'bg-green-400' },
};

export const VIDEO_STATUS = {
  Review: { label: 'در انتظار بررسی', color: 'bg-purple-100 text-purple-700 border border-purple-200' },
  Editing: { label: 'در حال ادیت', color: 'bg-blue-100 text-blue-700 border border-blue-200' },
  Approved: { label: 'تأیید شده', color: 'bg-green-100 text-green-700 border border-green-200' },
  Delivered: { label: 'تحویل داده شد', color: 'bg-emerald-100 text-emerald-700 border border-emerald-200' },
  Revision: { label: 'نیاز به اصلاح', color: 'bg-red-100 text-red-700 border border-red-200' },
};

export const TASK_STATUS = {
  Pending: { label: 'در انتظار', color: 'bg-slate-100 text-slate-700 border border-slate-200' },
  InProgress: { label: 'در حال انجام', color: 'bg-blue-100 text-blue-700 border border-blue-200' },
  Done: { label: 'انجام شد', color: 'bg-green-100 text-green-700 border border-green-200' },
  Overdue: { label: 'تأخیر دارد', color: 'bg-red-100 text-red-700 border border-red-200' },
};

export const EQUIPMENT_STATUS = {
  Available: { label: 'موجود', color: 'bg-green-100 text-green-700 border-green-200' },
  InUse: { label: 'در استفاده', color: 'bg-blue-100 text-blue-700 border-blue-200' },
  Maintenance: { label: 'تعمیر', color: 'bg-yellow-100 text-yellow-700 border-yellow-200' },
  Lost: { label: 'گم شده', color: 'bg-red-100 text-red-700 border-red-200' },
  Broken: { label: 'خراب شده', color: 'bg-orange-100 text-orange-700 border-orange-200' }
};

export const getStatusLabel = (status) => {
  return EQUIPMENT_STATUS[status]?.label || status;
};

export const getStatusConfig = (status) => {
  return EQUIPMENT_STATUS[status] || EQUIPMENT_STATUS.Available;
};

export const EMPLOYEE_STATUS = {
  Active: { label: 'فعال', color: 'bg-green-100 text-green-700 border border-green-200' },
  Freelance: { label: 'فریلنس', color: 'bg-yellow-100 text-yellow-700 border border-yellow-200' },
  Inactive: { label: 'غیرفعال', color: 'bg-slate-100 text-slate-700 border border-slate-200' },
};


// برای نگهداری با کدهای قدیمی (سازگاری)
export const PROJECT_TYPES = {
  Wedding: 'عروسی',
  Party: 'پارتی',
  Concert: 'کنسرت',
  Conference: 'کنفرانس',
  Music: 'موزیک ویدیو',
  Documentary: 'مستند',
  ShortFilm: 'فیلم کوتاه',
  Podcast: 'پادکست',
  Commercial: 'تبلیغاتی',
  Interview: 'مصاحبه',
  Training: 'آموزشی',
  Presentation: 'معرفی محصول'
};

export const EMPLOYEE_ROLES = {
  Editor: 'ادیتور',
  Cameraman: 'فیلم بردار',
  Photograph: 'عکاس',
  Director: 'کارگردان',
  Designer: 'دیزاینر',
  Assistant: 'دستیار',
};

export const EQUIPMENT_TYPES = {
  Camera: 'کمره',
  Lens: 'لنز',
  Light: 'نور',
  Drone: 'درون',
  Audio: 'صدا',
  Stabilizer: 'استابلایزر',
  Other: 'دیگر',
};

export const TASK_TYPES = {
  Shooting: 'شوتینگ',
  Editing: 'ادیت',
  ColorGrading: 'رنگ‌ بندی',
  SoundDesign: 'طراحی صدا',
  Review: 'بررسی',
  Delivery: 'تحویل',
  Other: 'دیگر',
};

export const ALERT_TYPES = {
  DeadlineWarning: { label: 'دیدلاین نزدیک', icon: '⏰', color: 'text-yellow-600' },
  VideoLate: { label: 'ویدیو دیر شده', icon: '🎬', color: 'text-orange-600' },
  PaymentDue: { label: 'پرداخت باقی', icon: '💰', color: 'text-red-600' },
  TaskOverdue: { label: 'تسک تأخیر دارد', icon: '📋', color: 'text-red-600' },
  EventToday: { label: 'رویداد امروز', icon: '📅', color: 'text-blue-600' },
  EmployeeOverload: { label: 'بار کاری زیاد', icon: '👷', color: 'text-purple-600' },
};
